<template>  
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Delete Profile
      </p>
      <a class="close-modal" aria-label="close" @click="closeModal()">
        <i class="material-icons">close</i>
      </a>
    </header>
    <section class="modal-card-body">

      <p>
        Are you sure you want to delete the profile called <strong>{{ profileToDelete.name }}</strong>
      </p>

      <div class="buttons-row">
        <button class="button button-secondary button-outline button-medium"
          @click="closeModal()"
        >
          Cancel
        </button>
        <button class="button button-primary button-medium" 
          :disabled="deleteLoading"
          @click="deleteProfile()"
        >
          Delete
        </button>
      </div>
     
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GAService from '@/services/ga.service';

@Component({
  components: {
  },
})
export default class DeleteProfileModal extends Vue {

  public deleteLoading: boolean = false;

  get profileToDelete() {
    return this.$store.state.profiles.profileToDelete;
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public async deleteProfile() {
    this.deleteLoading = true;

    try {
      GAService.sendEvent(this.$gtag, 'Profile', 'Deleted', this.profileToDelete.name);
      await this.$store.dispatch('deleteProfile', this.profileToDelete);
      this.$store.commit('setToastSuccess', 'Profile deleted successfully.');
      this.closeModal();
      this.deleteLoading = false;
    } catch (e) {
      this.$store.commit('setToastError', 'Error deleting profile.');
      this.deleteLoading = false;
    }
  }
}

</script>

<style scoped lang="scss">

.input {
  margin-top: 8px;
}

</style>